export default "__VITE_ASSET__BqK5ulV5__"